// ** Type import
import { VerticalNavItemsType } from 'src/@core/layouts/types'
import { userStorage } from 'src/utils/localStorage'

const navigationAdmin = (): VerticalNavItemsType => {
    if (userStorage.isAdmin()) {
        return [

        ]
    } else {
        return []
    }
}

const navigation = (): VerticalNavItemsType => [
    {
        title: 'Entregas',
        path: '/home',
        icon: 'iconamoon:delivery-fast-thin',
    },
    {
        title: 'Volquetes',
        path: '/volquetes',
        icon: 'ph:truck-thin',
    },
    ...navigationAdmin()
]

export default navigation
